// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"884":"dfdfc664","996":"a4bc6ecf"}[chunkId] + ".chunk.js";
};